import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes, FaWhatsapp } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"
import lingerie_video from "../images/lingerie_fitting_video.mp4";

const bandRows = [
  { size: 28, underbustIn: "26–27", underbustCm: "66–69" },
  { size: 30, underbustIn: "28–29", underbustCm: "71–74" },
  { size: 32, underbustIn: "30–31", underbustCm: "76–79" },
  { size: 34, underbustIn: "32–33", underbustCm: "81–84" },
  { size: 36, underbustIn: "34–35", underbustCm: "86–89" },
  { size: 38, underbustIn: "36–37", underbustCm: "91–94" },
  { size: 40, underbustIn: "38–39", underbustCm: "97–99" },
  { size: 42, underbustIn: "40–41", underbustCm: "102–104" },
  { size: 44, underbustIn: "42–43", underbustCm: "107–109" },
];

const cupRows = [
  { cup: "AA", diffIn: "0.5", diffCm: "1.3" },
  { cup: "A", diffIn: "1", diffCm: "2.5" },
  { cup: "B", diffIn: "2", diffCm: "5.1" },
  { cup: "C", diffIn: "3", diffCm: "7.6" },
  { cup: "D", diffIn: "4", diffCm: "10.2" },
  { cup: "DD / E", diffIn: "5", diffCm: "12.7" },
  { cup: "DDD / F", diffIn: "6", diffCm: "15.2" },
  { cup: "G", diffIn: "7", diffCm: "17.8" },
  { cup: "H", diffIn: "8", diffCm: "20.3" },
];

export default function CapSize({ route }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <div className="flex">
                    <button onClick={() => navigate(-1)} className="py-2 px-5 border rounded-sm my-2">Go Back</button>
                </div>
                <div className="grid md:grid-cols-2 gap-8 mt-10">
                    {/* Coupon */}
                    <div className="order-2 md:order-1 flex flex-col gap-2">
                        <p className="text-xl font-semibold mb-2">Book a free Fitting Appointment</p>
                        <div className='flex text-[#232323] flex-col text-start gap-y-2'>
                            <p className='text-sm'>Coming soon...</p>
                        </div>
                        <div className="flex">
                            <button onClick={() => window.open('https://api.whatsapp.com/message/EJMNVMDG22ZTP1?autoload=1&app_absent=0%0A', '_blank')} className="py-2 px-5 border border-[#00b47a] rounded-sm my-2 flex items-center gap-x-2"><FaWhatsapp color={'#00b47a'} /> Book on Whatsapp Now</button>
                        </div>
                        <div className="p-4 rounded-lg border">
                            <h2 className="text-lg font-semibold mb-2">Band size (Underbust)</h2>
                            <p className="text-sm text-gray-600 mb-3">
                            Measure snug under bust. Match your measurement range to the band size.
                            </p>

                            <div className="overflow-x-auto">
                            <table className="min-w-full text-sm border-collapse">
                                <thead>
                                <tr className="border-b">
                                    <th className="text-left py-2 pr-4">Band</th>
                                    <th className="text-left py-2 pr-4">Underbust (inches)</th>
                                    <th className="text-left py-2">Underbust (cm)</th>
                                </tr>
                                </thead>
                                <tbody>
                                {bandRows.map((row) => (
                                    <tr key={row.size} className="border-b last:border-b-0">
                                    <td className="py-2 pr-4 font-medium">{row.size}</td>
                                    <td className="py-2 pr-4">{row.underbustIn}</td>
                                    <td className="py-2">{row.underbustCm}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            </div>
                        </div>

                        <div className="p-4 rounded-lg border">
                            <h2 className="text-lg font-semibold mb-2">Cup size (Bust − Underbust)</h2>
                            <p className="text-sm text-gray-600 mb-3">
                            Measure bust at the fullest point. Cup is based on the difference between bust and underbust.
                            </p>

                            <div className="overflow-x-auto">
                            <table className="min-w-full text-sm border-collapse">
                                <thead>
                                <tr className="border-b">
                                    <th className="text-left py-2 pr-4">Cup</th>
                                    <th className="text-left py-2 pr-4">Difference (inches)</th>
                                    <th className="text-left py-2">Difference (cm)</th>
                                </tr>
                                </thead>
                                <tbody>
                                {cupRows.map((row) => (
                                    <tr key={row.cup} className="border-b last:border-b-0">
                                    <td className="py-2 pr-4 font-medium">{row.cup}</td>
                                    <td className="py-2 pr-4">{row.diffIn}</td>
                                    <td className="py-2">{row.diffCm}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            </div>

                            <div className="mt-3 text-xs text-gray-500">
                            Note: Sizing can vary by brand (and US/UK/EU systems differ). This is a helpful guideline, not a perfect rule.
                            </div>
                        </div>
                    </div>
                    {/* Totals */}
                    <video
                        src={lingerie_video}
                        className="w-full h-[500px] object-cover"
                        controls
                        autoPlay={false}
                        // width="100%" height="300"
                    />
                    {/* <iframe width="100%" height="300" src="https://www.youtube.com/embed/VtxvIDx9w3s?si=2aZ6V0LDV9-zdhky" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                </div>
            </div>
            <Footer />
        </div>
    )
}
